import React from 'react'
import Draggable from 'react-draggable'
import ModalDialog from 'react-bootstrap/ModalDialog'

class DraggableModalDialog extends React.Component {
  render() {
    return (
      <Draggable handle='.modal-header' bounds={{ top: -500, left: -500, right: 500, bottom: 500 }}>
        <ModalDialog {...this.props} />
      </Draggable>
    )
  }
}

export default DraggableModalDialog
